
import {CardPopupInformation} from '@colonist/game-card-types'
import {UIGamePopupSelectPlayerAndResourceCard} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectPlayerAndResourceCard'
import {UIGamePopupCardConfirmation} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupCardConfirmation'
import {UIMGamePopupCardConfirmation} from './UIMGamePopupCardConfirmation'
import {UIMGamePopupSelectCardToGiveToPlayer} from './UIMGamePopupSelectCardToGiveToPlayer'
import {UIGamePopupSelectCardToGiveToPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCardToGiveToPlayer'
import {PlayerColor} from '@colonist/game-states'

export class UIMGamePopupSelectPlayerAndResourceCard extends UIGamePopupSelectPlayerAndResourceCard {
    protected createPopupCardConfirmation(cancelPopupInformation: CardPopupInformation): UIGamePopupCardConfirmation {
        return new UIMGamePopupCardConfirmation(this.uiGameManager, cancelPopupInformation)
    }

    protected createPopupSelectCardToGiveToPlayer(playerReceivingCard: PlayerColor): UIGamePopupSelectCardToGiveToPlayer {
        return new UIMGamePopupSelectCardToGiveToPlayer(this.uiGameManager, this.popupImageAndDescription,
            this.selectionFormat.selectCardFormat, () => this.cancelSelectCard(), playerReceivingCard)
    }
}
